import { BaseElement, defineElement } from '@webtides/element-js';

/**
 * @property {string} pageId
 * @property {number} maxVisitedPages
 */
export default class VisitPage extends BaseElement {
    properties() {
        return {
            pageId: '',
            maxVisitedPages: 20,
        };
    }

    connected() {
        this.addToVisited();
    }

    addToVisited() {
        const visitedPages = new Set(JSON.parse(window.localStorage.getItem('visitedPages')));
        if (visitedPages.has(this.pageId)) {
            // so that the same page will be added at the bottom again
            visitedPages.delete(this.pageId);
        }
        visitedPages.add(this.pageId);
        if (visitedPages.size > this.maxVisitedPages) {
            const [firstPage] = visitedPages;
            visitedPages.delete(firstPage);
        }
        window.localStorage.setItem('visitedPages', JSON.stringify(Array.from(visitedPages)));
    }

}

defineElement('visit-page', VisitPage);
